function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export var toKebabCase = function(str) {
    var regex = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;
    var arr = str ? str.match(regex) : [];
    return arr.map(function(x) {
        return x.toLowerCase();
    }).join('-');
};
export var toCamelCase = function(str) {
    return (str.slice(0, 1).toLowerCase() + str.slice(1)).replace(/([-_ ]){1,}/g, ' ').split(/[-_ ]/).reduce(function(cur, acc) {
        return cur + acc[0].toUpperCase() + acc.substring(1);
    });
};
export var capitalize = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export var toPascalCase = function(str) {
    return capitalize(toCamelCase(str));
};
export var splitCamelOrPascalCase = function(str) {
    var camelCase = str.charAt(0).toUpperCase() + str.slice(1);
    return camelCase.replace(/([0-9A-Z])/g, ' $&');
};
export var capitalizeWords = function(str) {
    var arr = str && str.split(' ') || [];
    var capitalizedArray = arr.map(function(element) {
        return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
    });
    return capitalizedArray.join(' ');
};
export var capitalizeWord = function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
export var convertKeysToCamelCase = function(obj) {
    return Object.entries(obj).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[toCamelCase(key)] = value;
        return acc;
    }, {});
};
export var convertArrayKeysToCamelCase = function(array) {
    return array.map(convertKeysToCamelCase);
};
